import { Banner, BannerFormData } from "../types/banner";
import { get, post } from "./fetch.core";

export async function deleteBanner(id: string) {
  const res = await post("/admin/banner/delete", { bannerId: id });
  return res.data;
}

export async function updateBanner(id: string, data: BannerFormData) {
  const res = await post("/admin/banner/update", {
    bannerId: id,
    ...data,
  });

  return res.data;
}

export async function getBanner(id: string) {
  const res = await get<Banner>(`/admin/banner/get?bannerId=${id}`);
  return res.data;
}

export async function fetchBannerList(groupName: string) {
  const res = await get<Banner[]>(`/admin/banner/list?groupName=${groupName}`);
  return res.data;
}

export async function reOrderBanner(bannerIds: string[]) {
  const res = await post("/admin/banner/reOrder", { bannerIds });
  return res.data;
}

export async function uploadBanner(data: BannerFormData) {
  const rst = await post("/admin/banner/create", data);

  return rst.data;
}
